import { Button as BaseButton } from "@mui/material";
import styled from "@emotion/styled";

const StyledButton = styled(BaseButton)(({ theme, disabled }) => {
  const disabledCss = {
    color: `${theme.palette.disabled.main} !important`,
    backgroundColor: theme.palette.disabled.secondary,
    border: `1px solid ${theme.palette.disabled.main}`,
  };

  return {
    display: "flex",
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
    border: `1px solid ${theme.palette.primary.dark}`,
    textTransform: "unset",
    ...(disabled ? disabledCss : null),

    "&:hover": {
      border: `1px solid ${theme.palette.primary.light}`,
      backgroundColor: theme.palette.primary.veryDark,
    },
  };
});

export { StyledButton };
